// This is the landing page of the app
// This should be redirected to the dashboard by the router

const Home = () => {
  return null
}

export default Home
